export default __webpack_public_path__ + "static/media/018-cheese.7136f542.svg";